import React from 'react';
import { Box, Chip, Stack, useTheme } from '@mui/material';
import { CHOLA_COLORS } from '@/constants/filterStyles';

export interface FilterChip {
  label: string;
  onDelete: () => void;
  key: string;
}

interface AppliedFiltersChipsProps {
  chips: FilterChip[];
  compact?: boolean;
}

export function AppliedFiltersChips({
  chips,
  compact = false
}: AppliedFiltersChipsProps) {
  const theme = useTheme();

  if (chips.length === 0) {
    return null;
  }

  return (
    <Box sx={{ 
      p: compact ? 0.5 : 1.5, 
      bgcolor: CHOLA_COLORS.grey, 
      borderTop: `1px solid ${theme.palette.divider}` 
    }}>
      <Stack direction="row" spacing={compact ? 0.25 : 1} flexWrap="wrap" gap={compact ? 0.25 : 1}>
        {chips.map((chip) => (
          <Chip
            key={chip.key}
            label={chip.label}
            size="small"
            color="primary"
            onDelete={(e) => {
              e.stopPropagation();
              chip.onDelete();
            }}
            sx={{ 
              borderRadius: '4px',
              backgroundColor: CHOLA_COLORS.primary,
              fontSize: compact ? '0.55rem' : '0.75rem',
              height: compact ? '18px' : '24px',
              '& .MuiChip-deleteIcon': {
                color: 'white',
                fontSize: compact ? '0.65rem' : undefined,
                '&:hover': {
                  color: CHOLA_COLORS.accent,
                }
              }
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}

